module.exports = __webpack_public_path__ + "878941952f71eb2d6a42d5a05c28992c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W5.jpg
// module id = 3305
// module chunks = 0